import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading } from "./primitives";

const faqSchema = (items) => JSON.stringify({
  "@context": "https://schema.org", "@type": "FAQPage",
  mainEntity: items.map(([question, answer]) => ({ "@type": "Question", name: question, acceptedAnswer: { "@type": "Answer", text: answer } })),
});

export const MarketingFAQ = ({ items, id = "marketing-faq" }) => (
  <section className="mk-section" data-testid={id}><div className="mk-container mk-faq">
    <SectionHeading eyebrow="A little more clarity" title="Good questions. Straight answers." id={id} />
    <Accordion type="single" collapsible>{items.map(([question, answer], index) => <AccordionItem key={question} value={String(index)}>
      <AccordionTrigger data-testid={`${id}-question-${index}`}>{question}</AccordionTrigger><AccordionContent data-testid={`${id}-answer-${index}`}>{answer}</AccordionContent>
    </AccordionItem>)}</Accordion>
    <script type="application/ld+json" data-testid={`${id}-schema`} dangerouslySetInnerHTML={{ __html: faqSchema(items) }} />
  </div></section>
);
